<template>
    <FormSection title="CAHPS Survey" type="his-section" :full-height="false" :application-id="Number(application)">
        <template #content>
            <div class="col col-12">
                <section class="col py-3 px-4 g-0">
                    <div class="col">
                        <div class="form-check custom-checkbox pb-1 col-12">
                            <input
                                type="checkbox"
                                class="form-check-input"
                                id="no-contact"
                                v-model="referral.Contacts.NoContact"
                            />
                            <label class="form-check-label ms-1 col-12" for="no-contact">
                                Do Not Contact for CAHPS (When checked, please provide appropiate reason(s).)
                            </label>
                        </div>
                        <div class="my-2" v-if="referral.Contacts.NoContact">
                            <div>Reason for no contact for CAHPS</div>
                            <div v-for="option of Options" :key="`${option.label}-${option.value}`">
                                <div class="form-check custom-checkbox pb-1 col-12">
                                    <input
                                        type="checkbox"
                                        class="form-check-input"
                                        :id="`${option.value}-${option.label}`"
                                        :value="option.value"
                                        v-model="referral.Contacts.NoContactReasonCollection"
                                    />
                                    <label
                                        class="form-check-label ms-1 col-12"
                                        :for="`${option.value}-${option.label}`"
                                    >
                                        {{ option.label }}
                                    </label>
                                </div>
                                <div
                                    v-if="option.value === 4 && referral.Contacts.NoContactReasonCollection.includes(4)"
                                >
                                    <div class="d-flex mt-2 bg-white flex-column p-2 pb-4 ms-4 w-90">
                                        <label class="service-required-text-color">Other</label>
                                        <input
                                            type="text"
                                            class="form-control w-100"
                                            placeholder="Other Contact Person"
                                            v-model="referral.Contacts.NoContactReasonOther"
                                            maxlength="300"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="my-2 d-flex flex-column">
                            <small style="margin-bottom: -1rem">
                                Alternate CAHPS Contact (Applicable only when the patient is physically or mentally
                                incapable of completing survey.)</small
                            >

                            <div class="d-flex my-4">
                                <div class="form-check custom-checkbox form-check-inline mt-2">
                                    <input
                                        type="checkbox"
                                        id="same-as-patient-emergency-contact"
                                        class="form-check-input au-target"
                                        v-model="referral.Contacts.SameAsEmergencyContact"
                                        @change="markChapsAsEmergencyContact()"
                                    />
                                    <label class="form-check-label" for="same-as-patient-emergency-contact">
                                        <span class="me-1">Same as Patient Primary Emergency Contact</span>
                                    </label>
                                </div>
                            </div>
                            <div class="row px-1">
                                <div class="col-6">
                                    <div class="w-100"></div>
                                    <div class="form-group">
                                        <label for="auth-contact-first-name-add"> First Name </label>
                                        <input
                                            name="auth-contact-first-name-add"
                                            class="form-control"
                                            maxlength="50"
                                            type="text"
                                            placeholder="Enter First Name"
                                            v-model="referral.Contacts.PrimaryCahpsContact.FirstName"
                                        />
                                    </div>
                                    <div class="form-group">
                                        <label for="auth-contact-last-name-add"> Last Name </label>
                                        <input
                                            name="auth-contact-last-name-add"
                                            class="form-control"
                                            maxlength="50"
                                            type="text"
                                            placeholder="Enter Last Name"
                                            v-model="referral.Contacts.PrimaryCahpsContact.LastName"
                                        />
                                    </div>
                                    <div class="w-100"></div>
                                    <div class="form-group">
                                        <label for="auth-contact-relationship-add"> Relationship </label>
                                        <select
                                            class="form-select"
                                            name="auth-contact-relationship-add"
                                            v-model="referral.Contacts.PrimaryCahpsContact.RelationOption"
                                        >
                                            <option
                                                v-for="(relation, index) of referralOptions.relation"
                                                :key="index"
                                                :value="relation.value"
                                            >
                                                {{ relation.text }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="form-group">
                                        <label for="auth-contact-rel-desc"> Other </label>
                                        <input
                                            name="auth-contact-rel-desc"
                                            class="form-control"
                                            type="text"
                                            placeholder="Enter Relationship"
                                            v-model="referral.Contacts.PrimaryCahpsContact.Relationship"
                                        />
                                    </div>
                                    <div class="form-group">
                                        <label for="auth-contact-email-add"> Email </label>
                                        <input
                                            name="auth-contact-email-add"
                                            class="form-control"
                                            maxlength="50"
                                            type="text"
                                            placeholder="Enter Email"
                                            v-model="referral.Contacts.PrimaryCahpsContact.EmailAddress"
                                        />
                                    </div>
                                    <div class="form-group">
                                        <label for="referral-mobile-number-add">
                                            Mobile Phone
                                            <i
                                                class="fas fa-question-circle"
                                                v-tooltip="{
                                                    title: 'For emergency preparedness, patient will be contacted at this number. This will also populate to the emergency preparedness report.'
                                                }"
                                            ></i>
                                        </label>
                                        <input
                                            name="referral-mobile-number-add"
                                            type="text"
                                            class="form-control phone-number-input"
                                            maxlength="14"
                                            placeholder="Enter Number"
                                            v-number-only
                                            v-model="referral.Contacts.PrimaryCahpsContact.PrimaryPhone"
                                        />
                                    </div>
                                    <div class="form-group">
                                        <label for="referral-alternate-phone-add"> Alternate Phone </label>
                                        <input
                                            name="referral-alternate-phone-add"
                                            type="text"
                                            class="form-control phone-number-input"
                                            maxlength="14"
                                            placeholder="Enter Number"
                                            v-number-only
                                            v-model="referral.Contacts.PrimaryCahpsContact.AlternatePhone"
                                        />
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="col-12">
                                        <p>Mailing Address</p>
                                    </div>
                                    <ReferralAddressForm
                                        :address="referral.Contacts.PrimaryCahpsContact.Address"
                                        :zipChanged="handleZipChange"
                                        addressType="PrimaryCahpsContact"
                                        :county-data="chapsCountyData"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </template>
    </FormSection>
</template>

<script lang="ts" src="./ChapsSurvey.ts"></script>
